<template>
    <div class="menu" id="menu">
        <div class="logo">
            <img src="@/assets/img1/logo.svg" alt="">
        </div>
        <nav>
            <ul class="nav">
                <li class="selected">
                    <span :class="index == 1 ? 'tit item selected' : 'tit item'">
                        <RouterLink to="/">美国整柜直送</RouterLink>
                    </span>
                    <ul class="desc">
                        <li>
                            <el-tooltip effect="light" placement="right">
                                <span style="cursor: pointer;">第三方/FBA</span>
                                <div slot="content">
                                    <img style="width: 800px;" src="fba.jpg" alt="">
                                </div>
                            </el-tooltip>
                        </li>
                        <li>
                            <el-tooltip effect="light" placement="right">
                                <span style="cursor: pointer;">覆盖全美</span>
                                <div slot="content">
                                    <img style="width: 800px;" src="map.jpg" alt="">
                                </div>
                            </el-tooltip>
                        </li>
                        <li>实时报价</li>
                    </ul>
                </li>
                <li class="in_menu">
                    <div class="block">
                        <span>洛杉矶自营仓</span>
                    </div>
                    <ul>
                        <li :class="index == 2 ? ' item selected' : ' item'">
                            <RouterLink to="/DDU&DDP">尾程派送-第三方<br>DDU/DDP</RouterLink>
                        </li>
                        <li :class="index == 3 ? ' item selected' : ' item'">
                            <RouterLink to="/FBA">尾程派送-亚马逊FBA</RouterLink>
                        </li>
                        <li :class="index == 4 ? ' item selected' : ' item'">
                            <RouterLink to="/Info">清关 / 提柜 / 拆箱</RouterLink>
                        </li>
                    </ul>
                </li>
                <li>
                    <ul class="end">
                        <li :class="index == 5 ? ' item selected' : ' item'">
                            <RouterLink to="/delivery">美国派送距离查询</RouterLink>
                        </li>
                        <li :class="index == 6 ? ' item selected' : ' item'">
                            <RouterLink to="/tax">美国 {{ getCurrentYear() }} 关税</RouterLink>
                        </li>
                    </ul>
                </li>
                <!-- <li>
                    <div class="lang">
                        <span>语言：</span>
                        <el-select @change="changeLang" v-model="lang" placeholder="">
                            <el-option label="中文" value="zh_CN">
                            </el-option>
                            <el-option label="English" value="en_US">
                            </el-option>
                        </el-select>

                    </div>

                </li> -->
            </ul>
        </nav>
    </div>
</template>
  
<script>

export default {
    name: 'menuComponent',
    data: () => {
        return {
            index: 1,
            lang: 'zh_CN',
        }
    },
    methods: {
        changeLang(value) {
            this.$i18n.locale = value
            localStorage.setItem('language',value)
        },
        changeMenu(val) {
            this.index = val
        },
        getCurrentYear() {
            var currentDate = new Date();
            var currentYear = currentDate.getFullYear();
            return currentYear;
        },
    },
    mounted() {

        this.$mitt.on('changeMenu', (val => {
            this.changeMenu(val)
        }))
    }
}
</script>
<style scoped>
.menu {
    background-color: #173d76;
    color: white;
    height: 100vh;
    /* padding: 20px; */
    width: 210px;
    box-sizing: border-box;
    position: fixed;
    z-index: 999;
}

.lang {
    display: flex;
    align-items: center;

}


.logo {
    height: 86px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.logo img {
    width: 50%;
}

a {
    color: white;
}

.nav {
    /* background-color: red; */
    width: 100%;
    /* padding: 0 30px; */
    box-sizing: border-box;
    /* text-align: center; */
}

.nav>li {
    margin: 20px 0;
    font-size: 13px;
    padding: 0 20px;
}

.nav li a {
    color: rgba(255, 255, 255, .8);
    line-height: 15px;
    display: block;
}

.nav li {

    line-height: 30px;

}

.nav>li:nth-child(2) {
    border-top: 1px solid rgba(255, 255, 255, .5);
    border-bottom: 1px solid rgba(255, 255, 255, .5);
    padding: 20px 25px;
}

.in_menu {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 30px;

}

.in_menu .block {
    width: 10px;

}

.in_menu .block span {
    display: block;
    color: #00E1E9;
    line-height: 18px;
    font-weight: bold;
}

.in_menu li {
    line-height: 30px;
    font-size: 12px;
    /* margin: 10px 0; */
}

.in_menu li a {
    color: rgba(255, 255, 255, .8);
}

.desc {
    padding: 0 0 0 32px;
    margin: 8px 0;
}


.desc li {
    color: #F28122;
    line-height: 22px;
    background: url(@/assets/icon/point.svg) no-repeat left center;
    background-size: 8px;
    padding-left: 13px;
}

.end {
    padding: 0 2px;
}

.end li.item {

    padding-left: 35px;
    line-height: 30px;

}

.end li a {
    line-height: 30px;

}

.end li:first-of-type {
    background: url(@/assets/icon/position.svg) no-repeat left 10px center;
    background-size: 18px;
    background-position: 10px 14px;
}

.end li:last-of-type {
    background: url(@/assets/icon/sign.svg) no-repeat left 10px center;
    background-size: 18px;
    /* background-position: 0 4px; */

}

.tit {
    background: url(@/assets/icon/truck.svg) no-repeat left 10px center;
    background-size: 22px;
    display: block;
    padding: 10px 0px 10px 40px;
    font-size: 18px;
    font-weight: bold;
    color: white;

}

.tit a {
    line-height: 30px;
}

span.tit a {
    color: white;
}

.item {
    border-radius: 3px;
}

li.item {
    padding: 8px;

}

.item:hover,
.item.selected {
    background-color: #F28122 !important;
    color: #173d76;
}

.item:hover a,
.item.selected a {
    color: white;
    font-weight: bold;

}
</style>
